// PA analytics helper — fires gtag (GA4) events.
// No-op when GA4 isn't bootstrapped (i.e. no measurement ID in index.html meta tag).
//
// Bootstrap lives in public/index.html and only loads gtag if
// <meta name="ga-measurement-id" content="G-XXXXXXXXXX"> is set to a real ID.
// CMO/CRO provides the GA4 property ID; once set, every firePAEvent call lands as
// a GA4 event automatically.
//
// Event vocabulary mirrors the Master CTA tab (Sales & Marketing > CTAs > GA4 key events):
//   app_store_click          — Click to Play / App Store / getstarted
//   employer_cta_click       — Click "book a review" / employer CTA
//   roi_brief_download       — ROI brief downloaded
//   wizard_start             — Program wizard begin
//   wizard_complete          — Program wizard finish
//   contact_submit           — Contact form submitted
//   profile_view             — Physio bio page viewed
//   invite_landing           — Hit /invite/*
//   outbound_portal          — Click to portal.physioactivity.com

export function firePAEvent(eventName, params = {}) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    try {
        window.gtag('event', eventName, params);
    } catch (e) {
        // Silent fail — analytics must not break the app
    }
}
